import React from "react";
import "../../styles/start.css";
import MarekAboutFirst from "../../assets/img/MarekAbout_1.png";
import MarekAboutSecond from "../../assets/img/MarekAbout_2.png";

const Start = () => {
  return (
    <section className="wrapper" id="classes">
      <div className="container">
        <div className="start__wrapper">
          <div className="start__content">
            <h2 className="section__title">
              Ready to make a <span className="highlights">change?</span>
            </h2>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cumque
              amet facere nam nesciunt autem quasi consequuntur provident
              obcaecati eos! Ducimus modi praesentium mollitia veniam cumque
              laboriosam eos aspernatur dicta illo!
            </p>
          </div>
          <div className="start__img">
            <img
              src={MarekAboutFirst}
              alt=""
              data-aos="fade-left"
              data-aos-duration="1500"
            />
          </div>
        </div>
        <div className="start__wrapper">
          <div className="start__img">
            <img
              src={MarekAboutSecond}
              alt=""
              data-aos="fade-left"
              data-aos-duration="1500"
            />
          </div>

          <div
            className="start__content"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <h2 className="section__title">
              Ready to make a <span className="highlights">change?</span>
            </h2>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cumque
              amet facere nam nesciunt autem quasi consequuntur provident
              obcaecati eos! Ducimus modi praesentium mollitia veniam cumque
              laboriosam eos aspernatur dicta illo!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Start;
